import { render, staticRenderFns } from "./TargetEditor.vue?vue&type=template&id=3569d50b&scoped=true&"
import script from "./TargetEditor.vue?vue&type=script&lang=js&"
export * from "./TargetEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3569d50b",
  null
  
)

export default component.exports